import { OptimizationHoldoutKpi } from "../types";
import { isMadKeyShaped } from "../validators";
const KPIS = new Set(Object.values(OptimizationHoldoutKpi));
export const validators = {
    advertiserId: (_holdout, value) => isMadKeyShaped(value) ? undefined : "advertiserId must be a valid org key",
    lineItemId: (_holdout, value) => isMadKeyShaped(value) ? undefined : "lineItemId must be a valid line item key",
    kpi: (_holdout, value) => {
        if (typeof value === "string" && KPIS.has(value)) {
            return undefined;
        }
        const expected = [...KPIS].join(", ");
        return value
            ? `Holdouts are not available for KPI "${value}"; expected one of ${expected}`
            : `kpi is required; expected one of ${expected}`;
    }
};
/** Ending a holdout identifies it by its advertiser and line item; there is no KPI. */
export const endValidators = {
    advertiserId: validators.advertiserId,
    lineItemId: validators.lineItemId
};
//# sourceMappingURL=validators.js.map